import React from 'react';
import PropTypes from 'prop-types';
import { Container } from 'web-ui-components/lib/global/layout';
import { PageHeading } from 'web-ui-components/lib/typography/headings';

export const BacsUploadHeader = ({ title, description }) => (
	<Container className="u-padding-y-2" size="lg">
		<PageHeading isFlush data-test-id="bacs-upload">
			{title}
		</PageHeading>
		{description.map((desc) => (
			<p className="u-margin-top-1 u-margin-bottom-1" key={desc}>
				{desc}
			</p>
		))}
	</Container>
);

BacsUploadHeader.propTypes = {
	title: PropTypes.string,
	description: PropTypes.array,
};
